import React from "react";
import "./Home.css";

function Home() {
  return (
    <div className="home-section-container">
      <div className="home-content-split">
        <div className="home-text-content">
          <div className="title-text-cont">
            <h1>Hi, I'm Chappie!</h1>
            <p className="home-subtitle">
              Your trusted adventure buddy
            </p>
          </div>
        </div>

        <div className="home-image-content">
          <iframe src="https://drive.google.com/file/d/11HXp2IRvi4JLqNohKulLjheA_0c3N0bF/preview"></iframe>
        </div>
      </div>

      <div className="textCenter">
        <a
          href="https://www.outdoorsy.com/rv-rental/broomfield_co/2020_dodge-ram_promaster-2500-159_448895-listing?address=Broomfield%2C%20CO&filter%5Bfeature%5D=pet_friendly&filter%5Btype%5D=camper-van"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/OutdoorsyLogo.png"
            alt="Outdoorsy Logo"
            className="outdoorsy-logo"
          />
          <p className="rent-me-text">Rent Me</p>
        </a>
      </div>

      <div className="movCont">
        <img
          src="/rightSideOutside.jpg"
          alt="Chappy the Van"
          className="home-image"
        />
      </div>
    </div>
  );
}

export default Home;
